import React from 'react';
import styled, { keyframes } from 'styled-components';
import logo from '../logo.svg';

const pulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(27, 104, 165, 0.4);
  }
  
  70% {
    box-shadow: 0 0 0 8px rgba(27, 104, 165, 0);
  }
  
  100% {
    box-shadow: 0 0 0 0 rgba(27, 104, 165, 0);
  }
`;

const Logo = styled.img`
  animation: ${pulse} infinite 2s;
  height: 60px;
  border-radius: 50%;
  margin: 10px;

  &:hover {
    animation: none;
  }
`;

export default ({ ...props }) => <Logo src={logo} alt="logo" {...props} />;



// WEBPACK FOOTER //
// ./src/Header/logo.js